import { useState } from 'react';
import PropTypes from 'prop-types';
import UndoIcon from '@mui/icons-material/Undo';
import { styled } from '@mui/material';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Colors from 'constants/colors';
import RpClearFiltersModal from 'components/commons/RpClearFiltersModal';

const StyledButton = styled(Button)({
    fontWeight: 500,
    minWidth: 100,
    height: 38,
});

function RpFiltersModalActionButtons(props) {
    const [open, setOpen] = useState(false);

    const handleConfirmClearFilters = () => {
        props.onReset();
        setOpen(false);
    };

    return (
        <>
            <StyledButton
                variant="text"
                color="secondary"
                onClick={() => setOpen(true)}
                startIcon={<UndoIcon sx={{color: Colors.ERROR.TEXT}} />}
                sx={{
                    width: 110,
                    color: Colors.BLACK_60_OPAQUE,
                    '&.Mui-disabled': {
                        '& .MuiButton-startIcon': {
                            opacity: 0.4
                        }
                    }
                }}
                disabled={props.disabledClearFilters}
            >
                {props.clearText || 'Clear all'}
            </StyledButton>
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <StyledButton
                    onClick={props.applyFilters}
                    variant="contained"
                    disabled={props.disabledApplyFilters || props.fetching}
                    sx={{
                        '&.Mui-disabled': {
                            color: Colors.WHITE,
                        }
                    }}
                >
                    {props.applyText || 'Apply'}
                </StyledButton>
                {props.loading && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            background: 'rgba(255,255,255,0.5)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: 4,
                            zIndex: 1,
                        }}
                    >
                        <CircularProgress size={24} />
                    </div>
                )}
            </div>
            <RpClearFiltersModal
                open={open}
                onClose={() => setOpen(false)}
                onConfirm={handleConfirmClearFilters}
            />
        </>
    );
}

RpFiltersModalActionButtons.propTypes = {
    applyFilters: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    disabledClearFilters: PropTypes.bool,
    disabledApplyFilters: PropTypes.bool,
    clearText: PropTypes.string,
    applyText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]),
    onReset: PropTypes.func,
};

export default RpFiltersModalActionButtons;
